/**
 * OrbDocTutorialsBeginnerCompleteOrbitalENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsBeginnerCompleteOrbitalENDocScreen
 */

import { useOrbDocTutorialsBeginnerCompleteOrbitalENDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsBeginnerCompleteOrbitalENDocScreenLogic';
import type { OrbDocTutorialsBeginnerCompleteOrbitalENDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsBeginnerCompleteOrbitalENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsBeginnerCompleteOrbitalENDocView as OrbDocTutorialsBeginnerCompleteOrbitalENDocViewEntity } from '@app/shared';
import { OrbDocTutorialsBeginnerCompleteOrbitalENDocBodyView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalENDocBodyView';
import { OrbDocTutorialsBeginnerCompleteOrbitalENDocFooterView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalENDocFooterView';
import { OrbDocTutorialsBeginnerCompleteOrbitalENDocHeaderView } from '@/components/traits/OrbDocTutorialsBeginnerCompleteOrbitalENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsBeginnerCompleteOrbitalENDocScreenViewProps {
  config?: Partial<OrbDocTutorialsBeginnerCompleteOrbitalENDocScreenConfig>;
}

export function OrbDocTutorialsBeginnerCompleteOrbitalENDocScreenView({ config: propsConfig }: OrbDocTutorialsBeginnerCompleteOrbitalENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsBeginnerCompleteOrbitalENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsBeginnerCompleteOrbitalENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsBeginnerCompleteOrbitalEN" trait="OrbDocTutorialsBeginnerCompleteOrbitalENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsBeginnerCompleteOrbitalENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsBeginnerCompleteOrbitalENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsBeginnerCompleteOrbitalENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsBeginnerCompleteOrbitalENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsBeginnerCompleteOrbitalENDocScreenView;
